import * as S from "../../Style/Page/Social.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleSocial.js";
import HatPageTopLine from "../../Component/SocialPageTopLine.js";
import TableImgKor from "../../assets/GeneralBusiness/학원현황.png";
import TableImgEng from "../../assets/GeneralBusiness/학원현황영어.png";

const MainImg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/09. 숭의학원.8331d85429301b173ffa.png`;
const Img1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/10. 평양 숭의 여학교 전경.7903a098f2a487a7385b.png`;
const Img2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/11. 1953년 숭의학원 창립 50주년 기념식.7c437b58123f3cd6ffc8.png`;
const Img3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/12. 2003년 숭의학원 창립 100주년 기념식 및 중고등학교 준공식.76194603bfffaae85fd2.png`;
const Img4 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/13. 숭의 마펫기념교회 전경.e73a2006b995bb8e1f7a.png`;
const EducationBusiness = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"사회사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/SocialBusiness/SocialService">
                <div className="kor">사회사업</div>
                <div className="eng">Social Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"220px"}>
            <S.NavItem>
              <Link to="/SocialBusiness/EducationBusiness">
                <div className="kor">교육사업</div>
                <div className="eng">YoungAn Education Business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">복지사업</div>
                  <div className="eng">Welfare Services</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Scholarship">
                  <div className="kor">연암장학회</div>
                  <div className="eng">Yeonam Scholarship Foundation</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/EducationBusiness">
                  <div className="kor">교육사업</div>
                  <div className="eng">YoungAn Education Business</div>
                </Link>
              </S.NavItem>
              
              
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Obs">OBS</Link>
              </S.NavItem>
              {/* <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Museum">
                  <div className="kor">영안역사관</div>
                  <div className="eng">YoungAn History Museum</div>
                </Link>
              </S.NavItem> */}
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"교육사업"} titleeng={"YoungAn Education Business"} />
            <div className="page-subtitle">
              <div className="kor"><h2>학교법인 숭의학원 소개</h2></div>
              <div className="eng"><h2>Introduction of Soong Eui Educational Foundation</h2></div>
            </div>
            <img src={MainImg} alt="" className="fullsize-map" />
            <div className="page-text">
              <div className="kor">
                <div className="page-text-title"><h2>1. 학원 창립이념</h2></div>
                대한민국의 교육이념과 기독교 정신에 의거하여 고등교육, 중등교육, 초등교육 및 유아교육을 실시함을 목적으로
     합니다.
                <div className="page-text-title"><h2>2. 학원 연혁</h2></div>
                <span className="date">1903. 10</span> 마펫 목사, 평양에서
                숭의여학교 설립
                <br />
                <span className="date">1938. 03</span> 신사참배 거부로 자진 폐교
                <br />
                <span className="date">1953. 04</span> 서울에서 재단법인 숭의학원
                설립인가
                <br />
                <span className="date">1999. 04</span> 백성학 이사장 취임 <br />
                <span className="date">2003. 03</span> 숭의여자중·고등학교 대방동 신축 이전 개교 <br />
                <span className="date">2011. 11</span> 숭의여자대학교 별관 신축{" "}
                <br />
                <span className="date">2014. 12</span> 숭의마펫기념교회 헌당예배{" "}<br />
                <span className="date">2023. 10</span> 숭의학원 창립 120주년{" "}
                <div className="page-text-title"><h2>3. 학원 현황</h2></div>
              </div>
              <div className="eng">
                <div className="page-text-title"><h2>1. Founding Philosophy</h2></div>
                The purpose of this corporation is to provide higher education, secondary education, primary education, 
     and infant education in accordance with the Korean educational principles and the spirit of Christianity.
                <div className="page-text-title">2. History</div>
                <span className="date">1903. 10</span> Soong Eui Women's School was founded in Pyongyang by Dr. Samuel Austin Moffett
                <br />
                <span className="date">1938. 03</span> Voluntarily closed School with the refusal to participate in Japanese War Shrine.
                <br />
                <span className="date">1953. 04</span> Be approved to establish Soong Eui Foundation School in Seoul.
                <br />
                <span className="date">1999. 04</span> Baik, Sung Hak was Inaugurated as a Chief director.<br />
                <span className="date">2003.03</span> Relocated Soong Eui Girls' Middle and High School to a newly built campus in Daebang-dong.<br />
                <span className="date">2011. 11</span> The completion of the construction of the annex to Soongeui Women's College.{" "}
                <br />
                <span className="date">2014. 12</span> Established the Soong Eui Moffett Memorial Church.{" "}
                <br />
                <span className="date">2023.10</span> Celebrated the 120th anniversary of Soong Eui Educational Foundation.
                <div className="page-text-title"><h2>3. Overview of Educational Institutions</h2></div>
              </div>
              {/* <div className="page-text-title"> <div className="kor">학원 현황</div> <div className="eng">Present condition</div></div>
                <div className="link-line-text">
                  <span><div className="kor">1) 숭의여자대학교</div> <div className="eng">1) Soong Eui Women’s University</div></span>
                  <a href={"https://www.sewu.ac.kr/"}> <div className="kor">바로가기</div> <div className="eng">Link</div></a>
                </div>
                <div className="link-line-text">
                  <span><div className="kor">2) 숭의여자고등학교</div> <div className="eng"> 2) Soong Eui Girl’s High School</div></span>
                  <a href={"https://soongeui.sen.hs.kr/"}> <div className="kor">바로가기</div> <div className="eng">Link</div></a>
                </div>
                <div className="link-line-text">
                  <span><div className="kor">3) 숭의여자중학교</div> <div className="eng"> 3) Soong Eui Girl’s Middle School</div></span>
                  <a href={"https://seg.sen.ms.kr/"}> <div className="kor">바로가기</div> <div className="eng">Link</div></a>
                </div>
                <div className="link-line-text">
                  <span><div className="kor">4) 숭의초등학교</div> <div className="eng"> 4) Soong Eui Elementary School</div></span>
                  <a href={"https://soongeui.sen.es.kr/"}> <div className="kor">바로가기</div> <div className="eng">Link</div></a>
                </div>
                <div className="link-line-text">
                  <span><div className="kor">5) 숭의유치원</div> <div className="eng"> 5) Soong Eui Kindergarten</div></span>
                  <a href={"https://www.sewu.ac.kr/kindergarten/index.do"}>
                    <div className="kor">바로가기</div> <div className="eng">Link</div>{" "}
                  </a>
                </div>
                <S.ImgHolderFullsize className="mb-2">
                  <img src={Img1} className="holder-img" alt="" />
                  <div className="holder-name">
                    <div className="kor">평양 숭의 여학교 전경</div>
                    <div className="eng">Soong Eui Women’s School in Pyongyang</div>
                  </div>
                </S.ImgHolderFullsize>
                <S.ImgHolderFullsize className="mb-2">
                  <img src={Img2} className="holder-img" alt="" />
                  <div className="holder-name">
                    <div className="kor">1953년 숭의학원 창립 50주년 기념식</div>
                    <div className="eng">Soong Eui Educational Foundation 50th Anniversary Ceremony in 1953</div>
                  </div>
                </S.ImgHolderFullsize>
                <S.ImgHolderFullsize className="mb-2">
                  <img src={Img3} className="holder-img" alt="" />
                  <div className="holder-name">
                    <div className="kor">2003년 숭의학원 창립 100주년 기념식 및 중고등학교 준공식</div>
                    <div className="eng">
                      Soong Eui Educational Foundation 100th Anniversary Ceremony and
                      Middle and High School building dedication ceremony in 2003
                    </div>
                  </div>
                </S.ImgHolderFullsize>
                <S.ImgHolderFullsize className="mb-2">
                  <img src={Img4} className="holder-img" alt="" />
                  <div className="holder-name">
                    <div className="kor">숭의 마펫기념교회 전경</div>
                    <div className="eng">Soong Eui Moffett Memorial Church</div>
                  </div>
                </S.ImgHolderFullsize> */}

                <div className="page-text">
                  <div className="kor">
                    <img src={TableImgKor} alt="" className="fullsize-map kor" />
                  </div>
                  <div className="eng">                    
                    <img src={TableImgEng} alt="" className="fullsize-map eng" />
                  </div>
                </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default EducationBusiness;
